export const USER_DATA = ( state, payload ) => {
    state.userData = payload[0];
}

export const PROCESSING = ( state, payload) => {
    state.processing = payload;
}
export const GREETING = ( state, payload ) => {
    state.greeting = payload.body[0];
}

export const UPDATE_CHECK = ( state, payload ) => {
    state.checked = payload;
}

export const FIRST_VICTIM_CHECK = ( state, payload ) => {
    state.firstVictimCheck = payload;
}

export const SET_LINK_ORDER = ( state, payload ) => {
    state.linkOrder = payload;
}

export const SET_DEFAULT_PARAMS = ( state, payload ) => {
    state.defaultParams = payload;
}

export const END_SESSION = state => {
    state.checked = false;
    state.userData = null;
    state.login.TK = '';
    state.login.IMEI = '';
    state.defaultParams = {};
    state.covid.callingList = [];
    state.covid.nextVictim = null;
    state.firstVictimCheck = false;
}


// WEBPACK FOOTER //
// ./src/store/mutations.js